import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";

const CheckboxS1 = ({ className, label, position, checked, field, ...props }) => {
  const classes = cx("form-field", position && `form-field--position-${position}`, className);

  return (
    <div className={classes}>
      <label className="form-field__checkbox">
        {label && position !== "right" && <div className="form-field__label">{label}</div>}
        <input {...props} {...field} type="checkbox" className="form-field__checkbox-input" checked={field.value} name={field.name} />
        <div className="form-field__checkbox-mask" />
        {label && position === "right" && <div className="form-field__label">{label}</div>}
      </label>
    </div>
  );
};

CheckboxS1.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  position: PropTypes.oneOf(["left", "beet"]),
};

CheckboxS1.defaultProps = {
  className: null,
  label: null,
  position: "beet",
};

export default CheckboxS1;
